module.exports = __webpack_public_path__ + "static/collabo-a8dc6049148d0f8074c628734247baf6.png";